import Home from "./Home";
import Menu from "./Menu";
import Shop from "./Shop";
import Race from "./Race";
import Login from "./Login";
import Contact from "./Contact";
import Offices from "./Offices";
import WeAreJava from "./WeAreJava";
import InvestNow from "./InvestNow";
import Investment from "./Investment";
import InvestorForm from "./InvestorForm";
import UserDashboard from "./UserDashboard";
import LegalEntityInvestorForm from "./LegalEntityInvestorForm";
import Registration from "./Registration";
import AdminLogin from "./AdminLogin";
import NotFound from "./404";
import LandingPage from "./LandingPage";
import UserInvest from "./UserDashboard/UserInvest";
import BlogPage from "./BlogPage";
import TeamMember from "./TeamMember";
import About from "./About";
import ContactUs from "./ContactUs";
import OtpVerify from "./OtpVerify";
import Notifications from "./Notifications";
import NotificationDetails from "./NotificationDetails";
import  Franchise  from "./UserDashboard/Franchise";
import FranchiseDetail from "./UserDashboard/FranchiseDetail";
import TermOfUse from "./TermOfUse";
import PrivacyPolicy from "./PrivacyPolicy";

export {
  PrivacyPolicy,
  TermOfUse,
  NotificationDetails,
  Notifications,  
  OtpVerify,
  Home,
  Menu,
  Shop,
  Race,
  Login,
  Offices,
  Contact,
  WeAreJava,
  InvestNow,
  Investment,
  InvestorForm,
  UserDashboard,
  LegalEntityInvestorForm,
  Registration,
  AdminLogin,
  NotFound,
  LandingPage,
  UserInvest,
  BlogPage,
  TeamMember,
  About,
  ContactUs,
  Franchise,
  FranchiseDetail
};
